import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { Invite } from "../../types/api/Invite";

export default (orgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<Invite[]>(`invites_${orgId}`, async () => {
    return await Get<Invite[]>(
      `/api/invite/organization/${orgId}`,
      await getAccessTokenSilently()
    );
  });
};
